import { useContext } from "react"
import { ArquivosAplicativoContext } from "./ArquivosAplicativoContext"

export function useArquivosAplicativoContext() {
    return useContext(ArquivosAplicativoContext)
}
